import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-additional-note-modal',
  templateUrl: './additional-note-modal.component.html',
  styleUrls: ['./additional-note-modal.component.css']
})
export class AdditionalNoteModalComponent implements OnInit, OnDestroy {
  @Input() trip;
  @Output() additionalNoteAdded = new EventEmitter<any>();
  timeZone
  reasonSubmitted:boolean = false;

  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser().subscribe(data => {
      if (data) {
        this.timeZone = data.timeZone;
        console.log(this.timeZone);
      }
    })
  }

  addAdditionalNote() {
    this.reasonSubmitted = true;
    if(this.trip.note === ''){
      return
    }
    this.trip.note = this.trip.note + ' ' + moment().tz(this.timeZone).format("MM/DD/YYYY HH:mm a")
    this.assignTripService
      .addAdditionalNote(this.trip)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.additionalNoteAdded.emit(data);
        }
      });
  }

  closeModal() {
    this.additionalNoteAdded.emit(null);
  }

  ngOnDestroy(): void {
  }
}
